import { BrowserRouter, Route, Routes } from 'react-router-dom'

import WebRTCProvider from './library/web-rtc/WebRTCProvider'
import { LandingPage } from './pages/LandingPage'
import { PartyPage } from './pages/PartyPage'

const SOCKET_SERVER_URL = process.env.NODE_ENV === 'development' ? 'ws://192.168.100.5:8080' : 'wss://ws.shadeparades.com'

export default function App() {
  return (
    <BrowserRouter>
      <WebRTCProvider options={{ serverUrl: SOCKET_SERVER_URL }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/party/:sessionId" element={<PartyPage />} />
        </Routes>
      </WebRTCProvider>
    </BrowserRouter>
  )
}
